import { graphql } from "../gql";
import { useQuery } from "@apollo/client";

const GetAllUserGroupsQuery = graphql(`
  query getAllUserGroups {
    getAllUserGroups {
      id
      name
      slug
      thinkificBundleId
      onboardingLiveRequired
      onboardingLiveBookingWindowDays
      availability {
        weekDay
        timeIntervalTimezone
        timeIntervals {
          from
          to
        }
      }
    }
  }
`);

export function useAllUserGroups() {
  const { data, loading, refetch } = useQuery(GetAllUserGroupsQuery, {
    fetchPolicy: "cache-and-network",
  });

  return {
    userGroups: data?.getAllUserGroups ?? [],
    loading,
    refetch,
  };
}
